/**
 * @generated SignedSource<<ccbbfe1ef39d747541c96eb0ddfe4733>>
 * @relayHash d70af34751a7cf3f537bdc3c491b063b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID db9c4da3c9963a218be566480b811f4c280a90233adffbb68dbab88fb077418f

import type { ConcreteRequest, Query } from 'relay-runtime';
export type chatSimulator_agentIdentityQuery$variables = {
  helpCenterAri: string;
};
export type chatSimulator_agentIdentityQuery$data = {
  readonly csmAi_getAiHubByHelpCenterAri: {
    readonly agent?: {
      readonly conversationStarters?: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly greetingMessage?: string | null | undefined;
      readonly id?: string;
      readonly name?: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type chatSimulator_agentIdentityQuery = {
  response: chatSimulator_agentIdentityQuery$data;
  variables: chatSimulator_agentIdentityQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "ScalarField",
  "name": "greetingMessage"
},
v5 = {
  "kind": "ScalarField",
  "name": "message"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "chatSimulator_agentIdentityQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "concreteType": "CsmAiAgentConversationStarter",
                        "kind": "LinkedField",
                        "name": "conversationStarters",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/)
                        ]
                      }
                    ],
                    "type": "CsmAiAgent"
                  }
                ]
              }
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "chatSimulator_agentIdentityQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "concreteType": "CsmAiAgentConversationStarter",
                        "kind": "LinkedField",
                        "name": "conversationStarters",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/),
                          (v2/*: any*/)
                        ]
                      }
                    ],
                    "type": "CsmAiAgent"
                  }
                ]
              },
              (v2/*: any*/)
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "db9c4da3c9963a218be566480b811f4c280a90233adffbb68dbab88fb077418f",
    "metadata": {},
    "name": "chatSimulator_agentIdentityQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "73e0f5c420c1c9826c892a46bcf33273";

export default node;
